import { Input } from "../Input";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import {
  MenuItemOptionFormData,
  MenuItemOptionValueFormData,
} from "@/redux/services/menu/menu.type";
import { ButtonDelete } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface Props {
  register: UseFormRegister<MenuItemOptionFormData>;
  errors: FieldErrors<MenuItemOptionValueFormData> | undefined;
  menuOptionIndex: number;
  removeMenuItem: () => void;
  menuItemOptionValueLength: number;
  isTemplate: boolean;
}

const MenuItemOptionValue = ({
  register,
  errors,
  menuOptionIndex,
  removeMenuItem,
  menuItemOptionValueLength,
  isTemplate,
}: Props) => {
  return (
    <div className="bg-muted/40 border border-border rounded-md p-3 space-y-2">
      <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0">
          <Input
            type="text"
            id={`menuItemOptionValues.${menuOptionIndex}.title`}
            placeholder="Titre"
            variant="secondary"
            {...register(`menuItemOptionValues.${menuOptionIndex}.title`)}
            error={errors?.title}
          />
        </div>
        {menuItemOptionValueLength > 1 && (
          <ButtonDelete onClick={removeMenuItem} />
        )}
      </div>
      <div
        className={cn(
          "grid gap-2",
          isTemplate ? "grid-cols-2" : "grid-cols-1"
        )}
      >
        <Input
          type="number"
          placeholder="Position"
          variant="secondary"
          min={0}
          {...register(`menuItemOptionValues.${menuOptionIndex}.sortOrder`)}
          error={errors?.sortOrder}
        />
        {isTemplate && (
          <Input
            type="number"
            placeholder="Prix"
            variant="secondary"
            {...register(`menuItemOptionValues.${menuOptionIndex}.basePrice`)}
            error={errors?.basePrice}
          />
        )}
      </div>
    </div>
  );
};

export default MenuItemOptionValue;
